export enum tool {
    Paint,
    Eraser,
}
